<template>
    <div>
      <el-card>
        <h2>提现方式管理</h2>
  
        <el-table :data="accountList" border style="width: 100%; max-height: 600px; overflow-y: auto;">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column label="用户信息">
            <template #default="{ row }">
              <div>账号：{{ row.user.account }}</div>
              <div>用户名：{{ row.user.username }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="提现方式">
            <template #default="{ row }">
              <el-tag>{{ row.type === 'bank_card' ? '银行卡' : '支付宝' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="account" label="账号" />
          <el-table-column prop="name" label="账户名称" />
          <el-table-column prop="bank_name" label="银行名称">
            <template #default="{ row }">
              <span v-if="row.type === 'bank_card'">{{ row.bank_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template #default="{ row }">
              <el-tag :type="['danger', 'success', 'warning'][row.status]">
                {{ ['禁用','启用','允许修改'][row.status] }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="{ row }">
              <el-button type="primary" size="small" @click="handleEdit(row)">编辑</el-button>
              <el-button type="danger" size="small" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :total="total"
          @current-change="handlePageChange"
        />
      </el-card>

      <!-- 编辑弹窗 -->
      <el-dialog
        title="编辑提现方式"
        :visible.sync="dialogVisible"
        width="500px"
        :close-on-click-modal="false"
        :before-close="handleClose"
      >
        <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
          <el-form-item label="提现方式" prop="type">
            <el-select v-model="form.type" placeholder="请选择提现方式" style="width: 100%">
              <el-option label="银行卡" value="bank_card"></el-option>
              <el-option label="支付宝" value="alipay"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账号" prop="account">
            <el-input v-model="form.account" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="账户名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入账户名称"></el-input>
          </el-form-item>
          <el-form-item label="银行名称" prop="bank_name" v-if="form.type === 'bank_card'">
            <el-input v-model="form.bank_name" placeholder="请输入银行名称"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="2">允许修改</el-radio>
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleSave">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { getAccountInfo, deleteAccountInfo, updateAccountInfo } from '@/api/accountInfo';
  import { Dialog, Form, FormItem, Input, Select, Option, RadioGroup, Radio, Button, Message } from 'element-ui';

  export default {
    components: {
      Dialog,
      Form,
      FormItem,
      Input,
      Select,
      Option,
      RadioGroup,
      Radio,
      Button
    },
    data() {
      return {
        accountList: [],
        pagination: {
          page: 1,
          limit: 20
        },
        total: 0,
        // 弹窗相关数据
        dialogVisible: false,
        form: {
          id: null,
          type: '',
          account: '',
          name: '',
          bank_name: '',
          status: 1
        },
        rules: {
          type: [{ required: true, message: '请选择提现方式', trigger: 'change' }],
          account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
          name: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
          bank_name: [{ required: true, message: '请输入银行名称', trigger: 'blur' }],
          status: [{ required: true, message: '请选择状态', trigger: 'change' }]
        }
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit
        };
        const { data } = await getAccountInfo(params);
        this.accountList = data.items.map(item => ({
          ...item,
          user: item.user || { account: '', username: '' }
        }));
        this.total = data.total;
      },
      handlePageChange(page) {
        this.pagination.page = page;
        this.fetchData();
      },
      async handleDelete(row) {
        try {
          await this.$confirm('确定要删除该提现方式吗？', '提示', {
            type: 'warning'
          });
          await deleteAccountInfo(row.id);
          this.$message.success('删除成功');
          this.fetchData();
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error('删除失败');
          }
        }
      },
      handleEdit(row) {
  console.log('Edit button clicked', row);
  this.form = {
    id: row.id,
    type: row.type,
    account: row.account,
    name: row.name,
    bank_name: row.bank_name || '',
    status: row.status
  };
  this.dialogVisible = true;
  console.log('dialogVisible:', this.dialogVisible);
},
      handleClose() {
        this.dialogVisible = false;
      },
      // 保存编辑
      async handleSave() {
        try {
          const formRef = this.$refs.formRef;
          await formRef.validate();
          
          await updateAccountInfo(this.form.id, this.form);
          this.$message.success('更新成功');
          this.dialogVisible = false;
          this.fetchData();
        } catch (error) {
          console.error('保存失败', error);
          this.$message.error('保存失败');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .el-card {
    margin: 20px;
  }
  
  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  </style>